<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">通知管理</span>
      <div class="head-text">
        <el-button type="primary" @click="addData">新增</el-button>
        <el-button type="primary" @click="deleteinfo">删除</el-button>
      </div>
    </div>
    <div class="rygl-table">
      <el-table
        align="center"
        class="margin-20 table width100"
        v-loading="loading"
        :data="inform"
        height="72vh"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column align="center" prop="pmsg02" label="名称">
          <template slot-scope="scope">
            <p>{{ scope.row.pmsg02 }}</p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="user02"
          label="发布者"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="pmsg07N"
          label="更新时间"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              size="small"
              plain
              type="primary"
              @click="editor(scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              size="small"
              type="danger"
              @click="listRemove(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination
      align="center"
      class="mar-top30"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-sizes="[100, 50, 10]"
      v-loading="loading"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新建 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新建通知"
      :visible.sync="addDialogFormVisible"
    >
      <el-form :model="addForm1" label-width="80px" ref="addForm1">
        <el-form-item label="名称" prop="pmsg02">
          <el-input v-model="addForm1.pmsg02" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="pmsg07">
          <el-date-picker
            v-model="addForm1.pmsg07"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="标题颜色" prop="pmsg04">
          <div class="block">
            <el-color-picker v-model="addForm1.pmsg04"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="内容" prop="pmsg05">
          <ckediter4 ref="ck2" v-model="addForm1.pmsg05"></ckediter4>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUserSubmit" v-if="btnShow"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑公告信息"
      :visible.sync="editorDialogFormVisible1"
      width="50%"
      height="50%"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="名称" prop="pmsg02">
          <el-input
            :style="+'color:' + addForm.pmsg02"
            v-model="addForm.pmsg02"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="pmsg03">
          <el-input v-model="addForm.pmsg03" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标题颜色" prop="pmsg04">
          <div class="block">
            <el-color-picker v-model="addForm.pmsg04"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="时间" prop="pmsg07">
          <el-date-picker
            v-model="addForm.pmsg07"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="内容" prop="pmsg05">
          <ckediter4 ref="ck" v-model="addForm.pmsg05"></ckediter4>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateList" v-if="btnShow"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import ckediter4 from "@/components/ck.vue";
import {
  GetProjectNotice,
  AddProjectNotice,
  UpdateProjectNotice,
  RemoveProjectNotice,
} from "@/setAxios.js";
import { login } from "../../../../setAxios";
export default {
  name: "InformManagement",
  components: { ckediter4 },
  data() {
    return {
      btnShow: true,
      loading: false,
      total: 0,
      pagesize: 10,
      pagenum: 1,
      addDialogFormVisible: false,
      editorDialogFormVisible1: false,

      inform: [],
      addForm: {},
      addForm1: {
        pmsg06: localStorage.getItem("id"),
        pmsg08: localStorage.getItem("xid"),
      },
      removeID: [],
    };
  },
  methods: {
    //   批量删除
    deleteinfo() {
      if (this.removeID.length > 0) {
        this.loading = true;
        var listID = [];
        this.removeID.forEach((i, index) => {
          listID.push(i.pmsg01);
        });
        let params = {
          ids: listID.toString(),
        };
        RemoveProjectNotice(params).then((res) => {
          //(res);
          if (res.Code > 0) {
            this.$message({
              message: "批量删除成功",
              type: "success",
            });
            this.getData();
            this.loading = false;
          } else {
            this.$message.error("批量删除失败");
            this.loading = false;
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择需要删除的选项",
        });
      }
    },
    // 单项删除
    listRemove(row) {
      this.loading = true;
      this.$confirm("是否刪除该通知管理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          let params = {
            ids: row.pmsg01,
          };
          RemoveProjectNotice(params).then((res) => {
            //(res);
            this.loading = false;
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.loading = false;
        });
    },
    //   编辑通知公告
    editor(row) {
      this.editorDialogFormVisible1 = true;
      this.addForm = row;
    },
    // 编辑通知公告——确定按钮
    updateList() {
      this.addForm.pmsg05 = this.$refs.ck.ckeditor.getData();
      let params = {
        promsg: JSON.stringify(this.addForm),
      };
      UpdateProjectNotice(params).then((res) => {
      //   //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.getData();
          this.editorDialogFormVisible1 = false;
        } else {
          this.$message.error("编辑错误");
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.removeID = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    // 获取所有数据
    getData() {
      this.loading = true;
      let params = {
        id: localStorage.getItem("xid"),
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetProjectNotice({ params }).then((res) => {
        //(res);
        this.total = res.Data.total;
        this.inform = res.Data.list;
        this.loading = false;
        // //(this.inform);
      });
    },
    // 新建按钮
    addData() {
      this.addDialogFormVisible = true;
    },
    // 新建确定按钮
    addUserSubmit() {
      this.addForm1.pmsg03 = 0;
      this.addForm1.pmsg05 = this.$refs.ck2.ckeditor.getData();
      let params = {
        projectMsg: JSON.stringify(this.addForm1),
      };
      AddProjectNotice(params).then((res) => {
        //(res);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "新增通知成功！",
          });
        }
        this.addDialogFormVisible = false;
        this.addForm1 = [];
        this.getData();
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style scoped>
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.width100 {
  width: 100%;
}
.mar-top30 {
  margin-top: 30px;
}
</style>
